import User from "./User" ;
import Lead from "./Lead" ;
import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  UserBlockedLead extends  DBObject {  private static readonly _LEAD: number = 0 ;
  private static readonly _USER: number = 1 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _user: User = null ;
  private _lead: Lead = null ;
 public constructor ( d3eParams ? : Partial<{lead: Lead, user: User}> ) {
 super();

this.setLead(d3eParams?.lead ?? null);

this.setUser(d3eParams?.user ?? null);
 }
  public get d3eType (  ) : string {
 return 'UserBlockedLead' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get user (  ) : User {
 return this._user ; 
 }
  public setUser ( val : User ) : void {
 let isValChanged :boolean=this._user !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(UserBlockedLead._USER,this._user);

this.updateObservable('user',this._user,val);

this._user=val;

this.fire('user',this);
 }
  public get lead (  ) : Lead {
 return this._lead ; 
 }
  public setLead ( val : Lead ) : void {
 let isValChanged :boolean=this._lead !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(UserBlockedLead._LEAD,this._lead);

this.updateObservable('lead',this._lead,val);

this._lead=val;

this.fire('lead',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case UserBlockedLead._USER : {
 return this._user ; 
 }

case UserBlockedLead._LEAD : {
 return this._lead ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : UserBlockedLead {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :UserBlockedLead=( dbObj as UserBlockedLead );

obj.id=this.id;

obj.setUser(this._user);

obj.setLead(this._lead);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case UserBlockedLead._USER : {
 this.setUser(( value as User ));
 break; }

case UserBlockedLead._LEAD : {
 this.setLead(( value as Lead ));
 break; }
 }
 }
 }